import { stripIndices } from './paths';
import { getValueAtPath } from './valuePath';
import type { ScopeBinding } from './scopeBinding';

// Resolves the `scope` object passed into rule `when(ctx, value, scope)` predicates.
// - For group bindings: scope is the group root object.
// - For collection bindings: scope is the *indexed element* for the collection containing the leaf.
export function getConditionScopeForPath(
    pathWithIndices: string,
    values: unknown,
    scopeBindingByRuleKey: Map<string, ScopeBinding>
): unknown {
    // Rules are registered by a "ruleKey" that strips indices (e.g. `tradeIns.vin`).
    // At evaluation time we have an indexed path (e.g. `tradeIns[2].vin`), so we strip indices
    // to look up the precomputed binding.
    const ruleKey = stripIndices(pathWithIndices);

    const binding = scopeBindingByRuleKey.get(ruleKey);
    if (!binding) return undefined;

    if (binding.kind === 'group') {
        return getValueAtPath(values as any, binding.root);
    }

    // binding.kind === 'collection'
    // Expect the leaf path to start with `${root}[n]...` so we can extract `n` and return the
    // corresponding collection element as the scope.
    const root = binding.root;
    if (!pathWithIndices.startsWith(`${root}[`)) return undefined;

    const indexStart = root.length + 1;
    const indexEnd = pathWithIndices.indexOf(']', indexStart);
    if (indexEnd === -1) return undefined;

    const index = pathWithIndices.slice(indexStart, indexEnd);
    if (!/^\d+$/.test(index)) return undefined;

    return getValueAtPath(values as any, `${root}[${index}]`);
}
